import { render, staticRenderFns } from "./FontAwesomeIcon.vue?vue&type=template&id=30a9029e&scoped=true&"
import script from "./FontAwesomeIcon.vue?vue&type=script&lang=js&"
export * from "./FontAwesomeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a9029e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30a9029e')) {
      api.createRecord('30a9029e', component.options)
    } else {
      api.reload('30a9029e', component.options)
    }
    module.hot.accept("./FontAwesomeIcon.vue?vue&type=template&id=30a9029e&scoped=true&", function () {
      api.rerender('30a9029e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/FontAwesomeIcon.vue"
export default component.exports